import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Allevamento from "@/pages/Allevamento";
import Toelettatura from "@/pages/Toelettatura";
import Pensione from "@/pages/Pensione";
import Cibo from "@/pages/Cibo";
import Negozio from "@/pages/Negozio";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/allevamento" element={<Allevamento />} />
            <Route path="/toelettatura" element={<Toelettatura />} />
            <Route path="/pensione" element={<Pensione />} />
            <Route path="/cibo" element={<Cibo />} />
            <Route path="/negozio" element={<Negozio />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Contatti />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
